import { render, staticRenderFns } from "./NoAccounts.vue?vue&type=template&id=8a4b33f8"
import script from "./NoAccounts.vue?vue&type=script&lang=js"
export * from "./NoAccounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports